export default [
  {
    date: '27-05-2022',
    title: 'Easier reporting, cleaner design, and improved communications'
  },
  {
    date: '14-01-2021',
    title: 'Improved Results tab'
  },
  {
    date: '05-08-2020',
    title: 'Navigation & IATI page'
  },
  {
    date: '17-06-2020',
    title: 'Programme features & User access'
  }
]
